import DateProvider from 'web/contexts/DateContext';
import MoveDocumentNodeModalProvider from 'web/contexts/MoveDocumentNodeModalContext';
import RenameDocumentNodeModalProvider from 'web/contexts/RenameDocumentNodeModalContext';
import ConfirmProvider from 'web/contexts/ConfirmContext';
import AppFiltersProvider from 'web/contexts/AppFiltersContext';

export default function AuthorizedAppProviders({ children }) {
	return (
		<DateProvider>
			<MoveDocumentNodeModalProvider>
				<RenameDocumentNodeModalProvider>
					<ConfirmProvider>
						<AppFiltersProvider>{children}</AppFiltersProvider>
					</ConfirmProvider>
				</RenameDocumentNodeModalProvider>
			</MoveDocumentNodeModalProvider>
		</DateProvider>
	);
}
